
import React from 'react';

import './Learning_23062025.css';
  function Learning_23062025(){
    return(
         <div className="Learning_23062025">
        <h1>23/06/2025 Learning</h1>
        <h2>Hey Hi</h2>
      </div>
    ) ;
}
export default Learning_23062025;